require('./helpers/bundle-manifest').register(JSON.parse("{\"7G6IP\":\"index.js\",\"csbPg\":\"rumx-logo.5e36e89a.png\",\"9fXfQ\":\"index.css\"}"));